module.exports = __webpack_public_path__ + "static/media/wheel-frame.9bb185d6.png";